import { SET_USER_ID,LOGIN, LOGOUT, SET_NAME, SET_LAST_NAME, SET_EMAIL, SET_PROFILE, SET_COUNT, SET_ROLE ,SET_CHANGE_EMAIL, SET_USER, SET_TEAM_NAME} from "./types";
import axios from "../../utils/lib/axios";

export const login = (accessToken, permittedRoutes) => (dispatch) => {
  try {
    // axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    axios.interceptors.request.use(
      function (config) {
        config.headers["Authorization"] = "Bearer " + accessToken;
        return config;
      },
      null,
      { synchronous: true }
    );

    // save to the session storage
    sessionStorage.setItem("accessToken", accessToken);

    dispatch({
      type: LOGIN,
      payload: {
        accessToken,

        routes: permittedRoutes,
      },
    });
  } catch (error) {
    console.log(error)
  }
};

export const logout = () => (dispatch) => {
  axios.interceptors.request.use(
    (config) => {
      // Do something before request is sent

      delete config.headers["Authorization"];
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  // remove items from session storage
  sessionStorage.removeItem("accessToken");

  // axios.defaults.headers.common.Authorization = null;

  setTimeout(() => {
    dispatch({
      type: LOGOUT,
    });
  }, 70);
};

export const setName = (name) => (dispatch) => {
  dispatch({
    type: SET_NAME,
    payload: {
      name,
    },
  });
};

export const setLastName = (lastName) => (dispatch) => {
  dispatch({
    type: SET_LAST_NAME,
    payload: {
      last_name: lastName,
    },
  });
};

export const setEmail = (email) => (dispatch) => {
  dispatch({
    type: SET_EMAIL,
    payload: {
      email,
    },
  });
};

export const setChangeEmail = (changeEmail) => (dispatch) => {
  dispatch({
    type: SET_CHANGE_EMAIL,
    payload: {
      changeEmail,
    },
  });
};

export const setProfile = (url) => (dispatch) => {
  dispatch({
    type: SET_PROFILE,
    payload: {
      url,
    },
  });
};

export const setCount = (count) => (dispatch) => {
  dispatch({
    type: SET_COUNT,
    payload: {
      count,
    },
  });
};

export const setRole = (role) => (dispatch) => {
  dispatch({
    type: SET_ROLE,
    payload: {
      role,
    },
  });
};

export const setUserId = (userId) => (dispatch) => {
  dispatch({
    type: SET_USER_ID,
    payload: {
      userId
    },
  });
}

export const setUser = (profileData) => (dispatch) => {
  dispatch({
    type: SET_USER,
    payload: profileData
  });
};

export const setTeamName = (teamName) => (dispatch) => {
  dispatch({
    type: SET_TEAM_NAME,
    payload: {
      teamName,
    },
  });
};
